<template>
  <div>
    <div id="PremiumSeating" v-if="premiumSeating && selection">
      <b-container>
        <b-row>
          <b-col>
            <h1>Premium Seating</h1>
            <div class="line"></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="4" lg="5" md="12" class="left">
            <div class="buttons">
              <button
                class="btn btn-secondary"
                :class="{
                  'selected-button': selection === seatChoice.buttonText,
                }"
                v-for="seatChoice in premiumSeating"
                :key="seatChoice.buttonText + ' button'"
                @click="selection = seatChoice.buttonText"
              >
                {{ seatChoice.buttonText }}
              </button>
            </div>
            <p class="legal-text">
              Please note, all seat locations, game availability, and access to
              benefits are subject to change. Seating capacity as well as food
              and beverage options may be restricted and/or vary throughout the
              2024 season.
            </p>
          </b-col>
          <b-col xl="8" lg="7" md="12">
            <div
              v-for="seatChoice in selectedSeating"
              :key="seatChoice.buttonText + ' img'"
              class="image"
            >
              <img
                class="edge-cut-photo"
                :src="seatChoice.imgSrc"
                :alt="seatChoice.imgAlt"
              />
            </div>
            <div
              v-for="seatChoice in selectedSeating"
              :key="seatChoice.buttonText + ' button'"
            >
              <!-- Upper Text -->
              <div class="right">
                <img
                  v-if="seatChoice.logoSrc"
                  class="logo"
                  :src="seatChoice.logoSrc"
                  :alt="seatChoice.logoAlt"
                />

                <div v-html="seatChoice.info" class="text"></div>
                <ul>
                  <li
                    v-for="bulletPoint in seatChoice.bullets"
                    :key="bulletPoint"
                    v-html="bulletPoint"
                  ></li>
                </ul>
              </div>
            </div>
            <div class="buy-now">
              <a
                href="https://www.mlb.com/rays/tickets/premium"
                target="_blank"
              >
                <button class="btn btn-secondary">Buy Now</button></a
              >
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div class="table-wrapper">
            <div class="table-heading">
              <h3>
                Complimentary Parking for $20,000 Flexible Season Members and
                for the following Traditional Season Member Seating Categories
              </h3>
            </div>
            <div style="overflow-x: auto">
              <table class="table table-striped">
                <thead class="table-borderless">
                  <tr class="text-center align-middle">
                    <th scope="col">Lot #</th>
                    <th scope="col">DEX Imaging Home Plate Club</th>
                    <th scope="col">The Baldwin Group Club Full Season</th>
                    <th scope="col">Fieldside Box Full Season</th>
                    <th scope="col">Chalk Box Full Season</th>
                    <th scope="col">The Baldwin Group Club Half Season</th>
                    <th scope="col">Chalk Box Half Season</th>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr>
                    <td>Lot 1</td>
                    <td>2 Seats</td>
                    <td>4 Seats</td>
                    <td>4 Seats</td>
                    <td>4 Seats</td>
                    <td>N/A</td>
                    <td>N/A</td>
                  </tr>
                  <tr>
                    <td>Lot 2/6</td>
                    <td>N/A</td>
                    <td>2 Seats</td>
                    <td>2 Seats</td>
                    <td>2 Seats</td>
                    <td>4 Seats</td>
                    <td>4 Seats</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-row>
      </b-container>
    </div>
    <Banner bannerDivider="third" />
  </div>
</template>

<script>
import Banner from "@/components/sections/Banner/Banner";

export default {
  name: "PremiumSeating",
  components: {
    Banner,
  },
  data() {
    return {
      premiumSeatingData: [
        {
          buttonText: "DEX Imaging Home Plate Club",
          info:
            "<p>The <span>DEX IMAGING HOME PLATE CLUB</span> is the best way to experience Rays baseball with your clients, employees, family and friends. In addition to the exclusive seat location, your ticket to the DEX Imaging Home Plate Club includes the following premium amenities:</p>",
          bullets: [
            "Complimentary, all-inclusive food stations and bar",
            "Full access to The Baldwin Group Club and the Tropicana Room with private dining areas",
            "In-seat service",
            "Comfortable oversized leather seats located field level behind home plate",
            "Complimentary VIP Parking",
            "Invitations to special events",
            "Exclusive gifts",
            "A personal Rays Specialist assigned to your account",
          ],
          mapSrc: require("@/assets/images/rays-seating-map.png"),
          mapAlt: "Seating Map",
          imgSrc: require("@/assets/images/PremiumSeating/dex-imaging.png"),
          imgAlt: "Dex Imaging",
          logoSrc: require("@/assets/images/PremiumSeating/dex-logo.png"),
          logoAlt: "Dex Logo",
        },
        {
          buttonText: "The Baldwin Group Club",
          info:
            "<p><span>The Baldwin Group Club</span> is the perfect place to enjoy a Rays game with your guests in an upscale environment at a superior value. This exciting experience includes the following great perks:</p>",
          bullets: [
            "All-inclusive buffet (featured entrees and ballpark fare), plus bar service (beer and wine) <br />* Spirits will be available for purchase",
            "The Sweet Shop ‑ A delightful, appetizing area, featuring soft serve ice cream and baked goods, such as handmade pastries, tarts, cookies, eclairs and cannolis. Also offered are chocolates, candies, flavored coffees and espresso.",
            "In-seat service",
            "Comfortable lounge and dining areas",
            "Exclusive access to padded, leather seating",
            "Flat screen televisions so you do not miss any of the game",
            "Season Members receive invitations to special events",
            "Season Members receive the opportunity for complimentary parking based on the plan and number of seats purchased",
            "A personal Rays Specialist is assigned to your Season Membership account",
          ],
          mapSrc: require("@/assets/images/rays-seating-map.png"),
          mapAlt: "Seating Map",
          imgSrc: require("@/assets/images/PremiumSeating/rays-club.png"),
          imgAlt: "Rays Club",
          logoSrc: require("@/assets/images/PremiumSeating/The-Baldwin-Group-club.jpg"),
          logoAlt: "Baldwin Group club",
        },
        {
          buttonText: "Chalk Box",
          info:
            "<p>Combine location with luxury in the first few rows along the First Base Line. The <span>CHALK BOX</span> includes the following benefits:</p>",
          bullets: [
            "Comfortable oversized padded seats with armrests, cupholders and table",
            "Unique built-in storage area for each seat",
            "Season Members receive the opportunity for complimentary parking based on the number of seats purchased",
            "Season Members receive invitations to special events",
            "A personal Rays Specialist assigned to your account",
          ],
          mapSrc: require("@/assets/images/rays-seating-map.png"),
          mapAlt: "Seating Map",
          imgSrc: require("@/assets/images/PremiumSeating/chalk-box-2024.jpg"),
          imgAlt: "Chalk Box",
        },
        {
          buttonText: "Fieldside Box",
          info:
            "<p>The Fieldside Box is a great way to watch the game and be close to the action or right above the dugouts. This experience includes the following perks:</p>",
          bullets: [
            "Comfortable padded seating",
            "Season Members receive the opportunity for complimentary parking based on the number of seats purchased",
            "Season Members receive invitations to special events",
            "A personal Rays Specialist is assigned to your Season Membership account",
          ],
          mapSrc: require("@/assets/images/rays-seating-map.png"),
          mapAlt: "Seating Map",
          imgSrc: require("@/assets/images/PremiumSeating/PremiumSeatingFieldSideBox.png"),
          imgAlt: "Fieldside Box",
        },
      ],
      selection: "",
    };
  },

  computed: {
    plans() {
      return this.$store.getters
        .getSubSectionsByParent("5")
        .map((s) => s.title);
    },
    selectedSeating() {
      return this.premiumSeatingData.filter(
        (seats) => seats.buttonText === this.selection
      );
    },
    premiumSeating() {
      const _premiumSeating = this.plans.map((plan) => {
        const index = this.premiumSeatingData.findIndex(
          (p) => p.buttonText === plan
        );
        return this.premiumSeatingData[index];
      });
      return _premiumSeating;
    },
  },
  // preload the images so transitions look nicer
  mounted() {
    this.selection = this.premiumSeating?.[0]?.buttonText;
  },
};
</script>

<style lang="scss" scoped>
#PremiumSeating {
  padding-block: 150px 100px;
  background-image: url("~@/assets/images/bgImage_navy.jpg");
  background-size: cover;
  @media only screen and (max-width: $md) {
    padding-block: 50px;
  }
  .line {
    background-color: $yellow;
    width: 334px;
    height: 5px;
    margin: 15px 0 1em;
  }
  h1 {
    font-family: "Antique Olive";
    font-style: normal;
    font-weight: 700;
    font-size: 35px;
    line-height: 80%;
    text-transform: uppercase;
    color: #ffffff;

    @media only screen and (max-width: $sm) {
      font-size: 25px;
    }
  }
  .left {
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: stretch;
    .legal-text {
      font-family: "Futura";
      font-style: italic;
      font-weight: 500;
      font-size: 14px;
      line-height: 145%;
      align-items: center;
      color: #dad9d7;
      margin-top: auto;
      padding-block: 10px;
    }
    .buttons {
      display: flex;
      flex-wrap: nowrap;
      flex-direction: column;
      align-items: stretch;
      gap: 15px;
      margin-block: 10px;
      button {
        width: 100%;
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        text-transform: uppercase;
        color: white;
        border: 2px solid #ffffff;
        border-radius: 50px;
        padding: 10px 40px;
        background: transparent;
        &.selected-button {
          color: $yellow;
          border-color: $yellow;
        }
      }
    }
  }
  .image {
    overflow: hidden;
    display: flex;
    justify-content: center;

    img {
      width: calc(100% + 100px);
      max-width: unset;
    }
  }
  .right {
    font-family: "Futura";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 145%;
    color: #dad9d7;
    .text {
      margin-block: 20px !important;
    }
    .logo {
      margin-block: 20px;
      background: white;
      padding: 1em;
      max-width: 180px;
    }
  }
  .buy-now {
    text-align: center;
    button {
      width: 400px;
      font-family: "Futura";
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      text-transform: uppercase;
      color: #00285e;
      border: 2px solid $yellow;
      border-radius: 50px;
      padding: 10px 40px;
      background: $yellow;
    }
  }
  .table-wrapper {
    margin-block: 50px;
    width: 100%;
    .table-heading {
      background: #79bde8;
      padding: 15px 10px;
      h3 {
        font-family: "Futura";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 24px;
        text-align: center;
        color: #00285e;
      }
    }
    .table {
      background: #dad9d7;
      & > tbody > tr:nth-child(2n + 1) > td,
      & > tbody > tr:nth-child(2n + 1) > th {
        background-color: #b9b9b9;
      }
      th,
      td {
        font-size: 12px;
      }
      th {
        color: #161e26;
      }
    }
  }
}
</style>
